import { makeStyles, Theme } from "@material-ui/core";
import { boldFont } from "../../../utils/styles";

const locationOfflineStyles = makeStyles(
  (theme: Theme) => ({
    container: {
      backgroundColor: "#d84646",
      padding: "8px",
    },
    text: {
      ...boldFont,
      color: "white",
      textAlign: "center",
    },
  }),
  { index: 1 }
);

export default locationOfflineStyles;
